












































































































































































































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common";
import jsZip from "jszip";
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import SaitenBox from "../../components/SaitenBoxScoreStamp.vue";
import TextEditBox from "../../components/TextEditBox.vue";
import ScoreStampPreviewSidebar from '@/components/ScoreStampPreviewSidebar.vue';
import SaitenStickyNoteModal from "../../components/SaitenStickyNoteModal.vue";
import TextDirectionToggle from "../../components/TextDirectionToggle.vue"
import VSwatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css";
import { BModal, BCarousel, BPopover } from 'bootstrap-vue';
import { SplitterComponent, PanesDirective, PaneDirective, ResizingEventArgs } from "@syncfusion/ej2-vue-layouts"
import { Sheet, SheetField, FieldActivity, ParamFieldActivity, ScoreStamp, TensakuText, SaitenStickyNote } from "../../modules/teacher/SaitenInputScoreStamp";

export interface Data {
  sheet_id: string
  sheet_field_id: string
  next_room_sheet_id: number | null
  next_room_sheet_field: SheetField | null
  prev_room_sheet_id: number | null
  prev_room_sheet_field: SheetField | null
  prev_sheet_field: SheetField | null
  next_sheet_field: SheetField | null
  currentSheet: Sheet | null
  currentSheetField: SheetField | null
  fieldActivities: FieldActivity[]
  selectedIdx: number
  colCount: number
  inputScale: number
  fieldPadding: number
  fieldMargin: number
  windowHeight: number
  saitenMode: number
  sortKind: number
  scoreOptions: any[]
  selectedScore: number
  isTokutenModeDisabled: boolean
  processingTime: number
  correctImageUrl: string
  thickness: number
  isColCountChanged: boolean
  isWindowEventAdded: boolean
  allowResetSaitenLock: boolean
  isProcessingApi: boolean
  isUpdateConfirmed: boolean
  tensakuNumberOptions: any[]
  fontSizeOptions: any[]
  pcHelpFields: any[]
  tabletHelpFields: any[]
  carouselPageIdx: number
  modalIdx: number
  timer: any
  errors: string[]
  scoring_type_name: string
  isShowContextMenu: boolean
  pagePos: Common.Point
  stampPos: Common.Point
  contextButtonWidth: number
  contextButtonHeight: number
  contextScoreRows: any[]
  modeAreaLeft: number
  modeAreaTop: number
  modeAreaWidth: number
  keyCode: string
  pointerOffsetX: number
  pointerOffsetY: number
  isDragging: boolean
  drawColor: string
  direction: number
  mainAreaWidth: number
  mainAreaHeight: number
  horizonTopHeightPer: number
  horizonBottomHeightPer: number
  verticalLeftWidthPer: number
  verticalRightWidthPer: number
  separatorSize: number
  isDispCorrectImage: boolean
  correctImageScale: number
  scrollBarSize: number
  saitenBoxMarginTop: number
  is_first_room: boolean
  is_last_room: boolean
  isSortAsc: boolean
  fontSize: number
  lineHeight: number
  textColor: string
  selectedTensakuText: TensakuText
  isShowSessionMsg: boolean
  isWarningTimeReached: boolean
  warningDispTime: number
  isDispStudentInfo: boolean
  isExistsStudentNoCharacter: boolean
  isExistsStudentName: boolean
  verifyNo: number
  isPreviewSidebarVisible: boolean
  isInitialized: boolean
  copiedStamp: any
  isSaitenEnable: boolean
  isTensakuEnable: boolean
  saitenDisableReason: string
  selectedSaitenStickyNote: SaitenStickyNote
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "saiten-box": SaitenBox,
    "text-edit-box": TextEditBox,
    "ejs-splitter" : SplitterComponent,
    "e-panes": PanesDirective,
    "e-pane": PaneDirective,
    "v-swatches": VSwatches,
    "score-stamp-preview-sidebar": ScoreStampPreviewSidebar,
    "saiten-sticky-note-modal": SaitenStickyNoteModal,
    "text-direction-toggle": TextDirectionToggle,
  },
  setup(props, context){
    const saitenBoxRef = ref([]);
    const modalCorrectImageRef = ref<InstanceType<typeof BModal>>();
    const modalAddtionRef = ref<InstanceType<typeof BModal>>();
    const modalPcHelpRef = ref<InstanceType<typeof BModal>>();
    const modalTabletHelpRef = ref<InstanceType<typeof BModal>>();
    const modalPreviewImageRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();
    const saitenStickyNoteModalRef = ref<InstanceType<typeof SaitenStickyNoteModal>>();
    
    const SaitenModeEnum = Common.SaitenModeEnum;
    const CorrectStateEnum = Common.CorrectStateEnum;
    const DirectionEnum = Common.DirectionEnum;
    const NextFieldTypeEnum = Common.NextFieldTypeEnum;
    const SortKindEnum = Common.SaitenInputSortKindEnum;
    const CompareNoEnum = Common.CompareNoEnum;

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet_field_id: "",
      next_room_sheet_id: null,
      next_room_sheet_field: null,
      prev_room_sheet_id: null,
      prev_room_sheet_field: null,
      prev_sheet_field: null,
      next_sheet_field: null,
      currentSheet: null,
      currentSheetField: null,
      fieldActivities: null,
      selectedIdx: 0,
      colCount: 0,
      inputScale: 1,
      fieldPadding: 8,
      fieldMargin: 5,
      windowHeight: 0,
      saitenMode: SaitenModeEnum.None,
      sortKind: SortKindEnum.No,
      scoreOptions: new Array<object>(),
      selectedScore: 0,
      isTokutenModeDisabled: false,
      processingTime: 0,
      correctImageUrl: "",
      thickness: 2,
      isColCountChanged: false,
      isWindowEventAdded: false,
      isUpdateConfirmed: false,
      allowResetSaitenLock: true,
      isProcessingApi: false,
      tensakuNumberOptions: new Array<object>(),
      fontSizeOptions: new Array<object>(),
      pcHelpFields: [
        { key: "O・Aキー", img: [require("@/assets/images/keyboard_A.png"), require("@/assets/images/keyboard_O.png")], description: "正答○（KEY入力モードのみ有効）" },
        { key: "X・Fキー", img: [require("@/assets/images/keyboard_F.png"), require("@/assets/images/keyboard_X.png")], description: "誤答✕（KEY入力モードのみ有効）" },
        { key: "1-9キー", img: [require("@/assets/images/keyboard_1.png")], description: "スタンプ得点の得点を編集" },
        { key: "＋キー", img: [require("@/assets/images/keyboard_Plus.png")], description: "現在選択中のスタンプ得点からプラス1点に切り替え" },
        { key: "−キー", img: [require("@/assets/images/keyboard_Minus.png")], description: "現在選択中のスタンプ得点からマイナス1点に切り替え" },
        { key: "Sキー + マウス", img: [require("@/assets/images/keyboard_S.png")], description: "クリックした箇所に得点スタンプを出力" },
        { key: "Tキー + マウス", img: [require("@/assets/images/keyboard_T.png")], description: "クリックした箇所にテキストを出力" },
        { key: "得点スタンプ選択中にBackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中の得点スタンプを削除" },
        { key: "テキスト選択中にBackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中のテキストを削除" },
        { key: "得点スタンプ・テキスト未選択でBackSpaceキー", img: [require("@/assets/images/keyboard_Backspace.png")], description: "選択中の切出しの採点内容をクリア" },
        { key: "Ctrlキー + Cキー", img: [require("@/assets/images/keyboard_Ctrl.png"), require("@/assets/images/keyboard_C.png")], description: "選択中のテキスト・得点スタンプ・付箋をコピー" },
        { key: "Ctrlキー + Vキー", img: [require("@/assets/images/keyboard_Ctrl.png"), require("@/assets/images/keyboard_V.png")], description: "コピーしたテキスト・得点スタンプ・付箋をペースト" },
        { key: "Dキー + マウス", img: [require("@/assets/images/keyboard_D.png")], description: "自由線" },
        { key: "Eキー + マウス", img: [require("@/assets/images/keyboard_E.png")], description: "消しゴム" },
        { key: "Wキー", img: [require("@/assets/images/keyboard_W.png")], description: "模範解答画像を表示" },
        { key: "エンターキー", img: [require("@/assets/images/keyboard_Enter.png")], description: "次の生徒の切出し画像へ選択を変更" },
        { key: "Mキー", img: [require("@/assets/images/keyboard_M.png")], description: "採点内容を保存して次の設問へ移動" },
        { key: "Nキー", img: [require("@/assets/images/keyboard_N.png")], description: "採点内容を保存して次の教室へ移動" },
        { key: "Hキー", img: [require("@/assets/images/keyboard_H.png")], description: "保存して戻る" },
        { key: "右矢印キー", img: [require("@/assets/images/keyboard_Arrow_Right.png")], description: "次の生徒の切出し画像へ選択を変更" },
        { key: "左矢印キー", img: [require("@/assets/images/keyboard_Arrow_Left.png")], description: "前の生徒の切出し画像へ選択を変更" },
        { key: "Gキー", img: [require("@/assets/images/keyboard_G.png")], description: "拡大" },
        { key: "Qキー", img: [require("@/assets/images/keyboard_Q.png")], description: "縮小" },
        { key: "Bキー", img: [require("@/assets/images/keyboard_B.png")], description: "付箋" },
      ],
      tabletHelpFields: [
        { key: "画像上を長押し", img: null, description: "○×・得点スタンプ・テキストを選択するメニューが表示されます。<br>・○ → 次の画像へ遷移します。<br>・× → 次の画像へ遷移します。<br>・得点 → 長押しした箇所に得点スタンプが表示されます。<br>・テキスト → 長押しした箇所にテキストが表示されます。" },
        { key: "得点スタンプを長押し", img: null, description: "得点スタンプを削除します。" },
        { key: "テキストを長押し", img: null, description: "テキストを削除します。" },
        { key: "", img: [require("@/assets/images/keyboard_Arrow_Left_Right.png")], description: "次の画像、前の画像に遷移します。" },
        { key: "", img: [require("@/assets/images/keyboard_ModeArea.png")], description: "メニューボタンがON（緑色）になっている場合は、<font style='color:red'>長押し操作が反映されません。</font><br>ON（緑色）のアイコンを押すと、OFF（グレー）に戻ります。" },
      ],
      carouselPageIdx: 0,
      modalIdx: 0,
      timer: null,
      errors: [],
      scoring_type_name: null,
      isShowContextMenu: false,
      pagePos: new Common.Point(0, 0),
      stampPos: new Common.Point(0, 0),
      contextButtonWidth: 40,
      contextButtonHeight: 30,
      contextScoreRows: [],
      modeAreaLeft: 0,
      modeAreaTop: 0,
      modeAreaWidth: context.root.$store.state.isMobile ? 330 : 410,
      // かっこを復活させる場合は以下のサイズを適用する
      // modeAreaWidth: context.root.$store.state.isMobile ? 340 : 420,
      keyCode: "",
      pointerOffsetX: 0,
      pointerOffsetY: 0,
      isDragging: false,
      drawColor: "#FF0000",
      direction: DirectionEnum.Horizon,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      horizonTopHeightPer: 0.5,
      horizonBottomHeightPer: 0.7,
      verticalLeftWidthPer: 0.5,
      verticalRightWidthPer: 0.8,
      separatorSize: 10,
      isDispCorrectImage: true,
      correctImageScale: 50,
      scrollBarSize: 0,
      saitenBoxMarginTop: 15,
      is_first_room: false,
      is_last_room: false,
      isSortAsc: true,
      fontSize: 20,
      lineHeight: 0,
      textColor: "#FF0000",
      selectedTensakuText: null,
      isShowSessionMsg: false,
      isWarningTimeReached: false,
      warningDispTime: 9999,
      isDispStudentInfo: false,
      isExistsStudentNoCharacter: false,
      isExistsStudentName: false,
      verifyNo: 1,
      isPreviewSidebarVisible: false,
      isInitialized: false,
      copiedStamp: null,
      isSaitenEnable: false,
      isTensakuEnable: false,
      saitenDisableReason: null,
      selectedSaitenStickyNote: null,
    });

    /************************************************************
     * 選択中のfieldActivity
     ************************************************************/

    const selectedFieldActivity = computed((): FieldActivity | null => {
      const idx = state.selectedIdx;
      if(idx == null || idx < 0 || idx >= state.fieldActivities.length){
        return null;
      }
      return state.fieldActivities[idx];
    });

    /************************************************************
     * 選択中のテキスト要素のID
     ************************************************************/

    const selectedTensakuTextElemId = computed((): any => {
      if(!state.selectedTensakuText){
        return null;
      }
      if(!selectedFieldActivity.value){
        return null;
      }
      return `text-image-${state.direction}-${selectedFieldActivity.value.id}-${state.selectedTensakuText.idx}`;
    });

    /************************************************************
     * 選択中のテキストスタンプ切り替え SaitenBoxから呼ばれる
     ************************************************************/

    const changeSelectedTensakuText = (tensakuText: TensakuText) => {
      state.selectedTensakuText = tensakuText;
      if(state.selectedTensakuText){
        state.fontSize = tensakuText.font_size;
        state.lineHeight = tensakuText.line_height;
        state.textColor = tensakuText.color;
      }
    }

    /************************************************************
     * 出力済みテキストスタンプ文言編集後イベント
     ************************************************************/

    const changeText = () => {
      const param: any = {
        text: state.selectedTensakuText.text,
        fontSize: state.selectedTensakuText.font_size,
        lineHeight: state.selectedTensakuText.line_height,
        direction: state.selectedTensakuText.direction,
      }
      const size = Common.getTextSize(param);

      if(state.selectedTensakuText.direction == Common.DirectionEnum.Vertical){
        let diffW = size.width - state.selectedTensakuText.width;
        state.selectedTensakuText.x -= diffW;
      }

      state.selectedTensakuText.width = size.width;
      state.selectedTensakuText.height = size.height;
      state.selectedTensakuText.base64_text = Common.createBase64Text(state.selectedTensakuText);
      if(selectedFieldActivity.value){
        selectedFieldActivity.value.isTextEdited = true;
      }
    }

    /************************************************************
     * 出力済みテキストスタンプのフォントサイズ・行間変更後イベント
     ************************************************************/

    const textFormatChanged = (fontSize: number, lineHeight: number, textColor: string) => {
      state.fontSize = fontSize;
      state.lineHeight = lineHeight;
      state.textColor = textColor;
      state.selectedTensakuText.font_size = state.fontSize;
      state.selectedTensakuText.line_height = state.lineHeight;
      state.selectedTensakuText.color = state.textColor;
      const size = Common.getTextSize({text: state.selectedTensakuText.text, fontSize: state.fontSize, lineHeight: state.lineHeight, direction: state.selectedTensakuText.direction});
      state.selectedTensakuText.width = size.width;
      state.selectedTensakuText.height = size.height;
      state.selectedTensakuText.base64_text = Common.createBase64Text(state.selectedTensakuText);
      if(selectedFieldActivity.value){
        selectedFieldActivity.value.isTextEdited = true;
      }
    }

    /************************************************************
     * 横向きモードのスプリッターリサイズ
     ************************************************************/

    const horizonHeightPaneResizing = (e: ResizingEventArgs) => {
      state.horizonTopHeightPer = e.paneSize[0] / state.mainAreaHeight;
      state.horizonBottomHeightPer = e.paneSize[1] / state.mainAreaHeight;
      adjustLayout();
      fitToImageArea();
    }

    /************************************************************
     * 縦向きモードのスプリッターリサイズ
     ************************************************************/

    const verticalWidthPaneResizing = (e: ResizingEventArgs) => {
      state.verticalLeftWidthPer = e.paneSize[0] / (state.mainAreaWidth);
      state.verticalRightWidthPer = e.paneSize[1] / (state.mainAreaWidth);
      adjustLayout();
      fitToImageArea();
    }

    /************************************************************
     * 採点エリアwidth
     ************************************************************/

    const saitenBoxAreaWidth = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Horizon){
        return state.mainAreaWidth - state.scrollBarSize;
      }else{
        return state.mainAreaWidth * state.verticalRightWidthPer - state.scrollBarSize;
      }
    });

    /************************************************************
     * 採点エリアheight
     ************************************************************/

    const saitenBoxAreaHeight = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Vertical){
        return state.mainAreaHeight - state.scrollBarSize - state.saitenBoxMarginTop;
      }else{
        return state.mainAreaHeight * state.horizonBottomHeightPer - state.scrollBarSize - state.saitenBoxMarginTop
      }
    });

    /************************************************************
     * 模範解答エリアwidth
     ************************************************************/

    const correctImageAreaWidth = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Horizon){
        return state.mainAreaWidth - state.scrollBarSize;
      }else{
        return state.mainAreaWidth * state.verticalLeftWidthPer - state.scrollBarSize;
      }
    });

    /************************************************************
     * 模範解答エリアheight
     ************************************************************/

    const correctImageAreaHeight = computed((): any => {
      if(!state.isDispCorrectImage || state.direction == DirectionEnum.Vertical){
        return state.mainAreaHeight - state.scrollBarSize - state.saitenBoxMarginTop;
      }else{
        return state.mainAreaHeight * state.horizonTopHeightPer - state.scrollBarSize - state.saitenBoxMarginTop
      }
    });

    /************************************************************
     * 画面レイアウト縦横モード切り替え
     ************************************************************/

    const changeDirection = (direction: number) => {
      if(state.direction != direction){
        state.direction = direction;
        fitToImageArea();
      }
    }

    /************************************************************
     * 模範解答imgタグのCSS
     ************************************************************/

    const correctImageStyle = computed((): any => {
      const style: any = {};
      style["width"] = `${state.currentSheetField.baseWidth * state.correctImageScale / 100}px`;
      style["height"] = `${state.currentSheetField.baseHeight * state.correctImageScale / 100}px`;
      style["margin-top"] = `${state.saitenBoxMarginTop}px`;
      style["padding-left"] = `${state.fieldPadding}px`;
      style["padding-right"] = `${state.fieldPadding}px`;
      style["padding-bottom"] = `${state.fieldPadding}px`;
      return style;
    });

    /************************************************************
     * コンテキストメニューのボタンStyle
     ************************************************************/

    const contextButtonStyle = computed((): any => {
      return {width: `${state.contextButtonWidth}px`, height: `${state.contextButtonHeight}px`}
    });

    /************************************************************
     * スライダーの値を倍率に変換
     ************************************************************/

    const scale = computed((): any => {
      return Number(state.inputScale) / 100;
    });

    /************************************************************
     * コンテキストメニューのStyle
     ************************************************************/

    const contextAreaStyle = computed((): any => {
      const padding = 18;
      const rowCnt = state.contextScoreRows.length + 1;
      let colCnt = state.contextScoreRows.map((x: number[]) => x.length).reduce((a,b)=>Math.max(a,b));
      // 部分点数が1の場合、○×・テキストボタンがあるので4列とする
      if(colCnt < 4){
        colCnt = 4;
      }
      return {
        left: `${state.pagePos.x - 10}px`,
        top: `${state.pagePos.y - (state.contextButtonHeight * rowCnt + padding * 2) + 10}px`,
        width: `${state.contextButtonWidth * colCnt + padding * 2}px`,
        height: `${state.contextButtonHeight * rowCnt + padding * 2}px`,
        padding: `${padding}px`,
      }
    });

    /************************************************************
     * ショートカットキー使用可否判定
     ************************************************************/

    const isShortcutEditable = computed((): any => {
      return !state.isProcessingApi && !context.root.$store.state.isShowingMsgBox && !state.isPreviewSidebarVisible;
    });

    /************************************************************
     * モーダル表示対象の答案画像
     ************************************************************/

    const base64PreviewImages = computed((): any => {
      return state.fieldActivities[state.modalIdx].base64PreviewImages;
    });

    /************************************************************
     * ボタンからフォーカス解除
     ************************************************************/
    const blur = () => {
      const current = document.activeElement;
      if(current != null){
        (current as HTMLElement).blur();
      }
    }

    /************************************************************
     * 画面のレイアウト整形
     * 初期表示・ウィンドウリサイズ・拡大縮小ボタン押下時に発動
     ************************************************************/

    const adjustLayout = () => {
      
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const imageArea = document.getElementById("image-area");
      const tableArea = document.getElementById("table-area");
      const footerArea = document.getElementById("footer-area");
      const footerBorder = document.getElementById("footer-border");
      state.windowHeight = windowHeight;
      
      // 画像表示エリアの高さを画面サイズに合わせる
      if(imageArea != null && footerArea != null){
        state.mainAreaHeight = (windowHeight - imageArea.offsetTop - footerArea.clientHeight - footerBorder.offsetHeight - 5);
        state.mainAreaWidth = windowWidth - tableArea.offsetWidth;
        imageArea.style.height = `${state.mainAreaHeight}px`;
      }

      // 生徒一覧表示エリアの高さを画面サイズに合わせる
      if(tableArea != null && footerArea != null){
        tableArea.style.height = (windowHeight - tableArea.offsetTop - footerArea.clientHeight - footerBorder.offsetHeight - 5) + "px";
        // tableArea.style.width = (windowWidth - state.mainAreaWidth - 20) + "px";
      }

      // 添削ボタンエリアの座標リセット
      if(state.isSaitenEnable){
        const iconDirectionH = document.getElementById("icon-direction-h")
        const tensakuButtonArea = document.getElementById("tensaku-button-area");
        state.modeAreaTop = 5;
        state.modeAreaLeft =  iconDirectionH.getBoundingClientRect().left - tensakuButtonArea.offsetWidth - 10;
      }
    };

    /************************************************************
     * 倍率を加味した切り出し画像のWidth
     ************************************************************/

    const fieldImageWidth = computed((): any => {
      return state.currentSheetField.baseWidth * scale.value;
    });

    /************************************************************
     * 倍率を加味した切り出し画像WrapのWidth
     ************************************************************/

    const fieldWrapWidth = computed((): any => {
      return fieldImageWidth.value + (state.fieldPadding * 2);
    });

    /************************************************************
     * 倍率を加味した切り出し画像のHeight
     ************************************************************/

    const fieldImageHeight = computed((): any => {
      return state.currentSheetField.baseHeight * scale.value;
    });

    /************************************************************
     * 倍率を加味した切り出し画像WrapのHeight
     ************************************************************/

    const fieldWrapHeight = computed((): any => {
      return fieldImageHeight.value + (state.fieldPadding * 2);
    });

    /************************************************************
     * 切り出し画像エリア内に画像が全て収まるように整形
     ************************************************************/

    const fitToImageArea = () => {
      // 採点エリアの倍率設定
      let scaleW = (saitenBoxAreaWidth.value - (state.fieldMargin * 2) - (state.fieldPadding * 2)) / (state.currentSheetField.baseWidth);
      let scaleH = (saitenBoxAreaHeight.value - (state.fieldPadding * 2)) / (state.currentSheetField.baseHeight);
      state.inputScale = (scaleW > scaleH ? scaleH : scaleW) * 100;

      // 模範解答エリアの倍率設定
      scaleW = (correctImageAreaWidth.value) / (state.currentSheetField.baseWidth);
      scaleH = (correctImageAreaHeight.value) / (state.currentSheetField.baseHeight);
      state.correctImageScale = (scaleW > scaleH ? scaleH : scaleW) * 100;
    }

    /************************************************************
     * 拡大
     ************************************************************/

    const scaleUp = () => {
      blur();
      state.inputScale += 5;
    };

    /************************************************************
     * 縮小
     ************************************************************/

    const scaleDown = () => {
      blur();
      if(state.inputScale > 10){
        state.inputScale -= 5;
      }
    };

    /************************************************************
     * 模範解答モーダル表示
     ************************************************************/

    const showModalCorrectImage = () => {
      blur();
      state.isDispCorrectImage = !state.isDispCorrectImage;
      context.root.$nextTick(() => {
        fitToImageArea();
      });
      // modalCorrectImageRef.value.show();
    };

    /************************************************************
     * メモモーダル表示
     ************************************************************/

    const showModalMemo = () => {
      blur();
      modalAddtionRef.value.show();
    };

    /************************************************************
     * PC用ヘルプモーダル表示
     ************************************************************/

    const showModalPcHelp = () => {
      blur();
      modalPcHelpRef.value.show();
    };

    /************************************************************
     * タブレット用ヘルプモーダル表示
     ************************************************************/

    const showModalTabletHelp = () => {
      blur();
      modalTabletHelpRef.value.show();
    };

    /************************************************************
     * 全体画像モーダル表示
     ************************************************************/

    const showPreviewImage = async (idx: number) => {
      blur();
      state.modalIdx = idx;

      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      state.carouselPageIdx = 0;
      modalPreviewImageRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadImage = async () => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const student_id = state.fieldActivities[state.modalIdx].sheetActivity.student_id;
      await http.get(`/api/teacher/saiten_input_score_stamp/download_preview_image/${state.sheet_id}/${student_id}/${state.carouselPageIdx + 1}`).then(async response => {
        response.data.base64_images.forEach((x: string) => {
          state.fieldActivities[state.modalIdx].base64PreviewImages.push(x);
        });
      })
      .catch(async error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/

    const carouselPrev = async () => {
      // carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.currentSheet.page_count - 1;
      }

      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/

    const carouselNext = async () => {
      // carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.currentSheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }

      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalExaminee = async () => {
      
      if(state.modalIdx > 0){
        state.modalIdx--;
      }else{
        state.modalIdx = state.fieldActivities.length - 1;
      }

      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      // state.carouselPageIdx = 0;
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalExaminee = async () => {
      if(state.modalIdx + 1 < state.fieldActivities.length){
        state.modalIdx++;
      }else{
        state.modalIdx = 0;
      }
      
      if(base64PreviewImages.value.length == 0){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage()
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }

      // state.carouselPageIdx = 0;
      // modalPreviewImageRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 並び順切り替え
     ************************************************************/

    const changeSortKind = (sortKind: number, isInitialize: boolean = false) => {
      blur();

      if(isInitialize){
        // 初期表示のソートは昇順にする
        state.isSortAsc = true;
      }else if(state.sortKind == sortKind){
        // 現在設定されているソートと同じボタン押下の場合は昇順・降順を切り替え
        state.isSortAsc = !state.isSortAsc;
      }

      state.sortKind = sortKind;
      
      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });

      if (sortKind == SortKindEnum.No) {
        state.fieldActivities.sort((a, b) => {
          if (state.isSortAsc) {
            return a.sheetActivity.student_id - b.sheetActivity.student_id;
          } else {
            return b.sheetActivity.student_id - a.sheetActivity.student_id;
          }
        });
      } else if (sortKind == SortKindEnum.CorrectState) {
        state.fieldActivities.sort((a, b) => {
          if (a.score != b.score) {
            if (state.isSortAsc) {
              return b.score - a.score;
            } else {
              return a.score - b.score;
            }
          } else {
            if (state.isSortAsc) {
              return a.sheetActivity.student_id - b.sheetActivity.student_id;
            } else {
              return b.sheetActivity.student_id - a.sheetActivity.student_id;
            }
          }
        });
      } else {
        state.fieldActivities.sort((a, b) => {
          if (a.cutImageFileSize != b.cutImageFileSize) {
            if (state.isSortAsc) {
              return a.cutImageFileSize - b.cutImageFileSize;
            } else {
              return b.cutImageFileSize - a.cutImageFileSize;
            }
          } else {
            if (state.isSortAsc) {
              return a.sheetActivity.student_id - b.sheetActivity.student_id;
            } else {
              return b.sheetActivity.student_id - a.sheetActivity.student_id;
            }
          }
        });
      }
    }

    /************************************************************
     * 採点完了後の次画面種別（次の設問 or 次の教室）
     ************************************************************/

    const changeNextFieldType = (nextFieldType: number) => {
      blur();
      context.root.$store.commit("setNextFieldType", nextFieldType);
    }

    /************************************************************
     * 添削モードエリアドラッグ系処理
     ************************************************************/

    const modeAreaHeaderPointerDown = (e: PointerEvent) => {
      (e.target as HTMLElement).setPointerCapture(e.pointerId);
      state.pointerOffsetX = e.offsetX + 3;
      state.pointerOffsetY = e.offsetY + 14;
      state.isDragging = true;
    }

    const modeAreaHeaderPointerMove = (e: PointerEvent) => {
      if(state.isDragging){
        e.preventDefault();
        state.modeAreaLeft = e.clientX - state.pointerOffsetX;
        state.modeAreaTop = e.clientY - state.pointerOffsetY;
      }
    }

    const modeAreaHeaderPointerUp = (e: PointerEvent) => {
      (e.target as HTMLElement).releasePointerCapture(e.pointerId);
      state.isDragging = false;
    }

    const modeAreaTouchMove = (e: TouchEvent) => {
      if(state.isDragging){
        e.preventDefault();
      }
    }

    /************************************************************
     * 採点モード切り替え
     ************************************************************/

    const changeSaitenMode = (saitenMode: number) => {
      blur();
      if(state.saitenMode == saitenMode){
        state.saitenMode = SaitenModeEnum.None;
      }else{
        state.saitenMode = saitenMode;
      }
    }

    /************************************************************
     * 採点BOXからのemitによる採点モード切り替え
     ************************************************************/

    const changeSaitenModeBySaitenBox = (saitenMode: number) => {
      state.saitenMode = saitenMode;
    }

    /************************************************************
     * 正答or誤答採点
     ************************************************************/

    const updateCorrectState = async (correct_state: number, score: number) => {

      state.isShowContextMenu = false;

      if(!selectedFieldActivity.value){
        return;
      }
      selectedFieldActivity.value.scoreStamps = [];
      setCorrect(selectedFieldActivity.value, correct_state, score);

      if(state.selectedIdx + 1 == state.fieldActivities.length){
        if(state.fieldActivities.filter(x => x.correct_state == null).length == 0){
          setTimeout(async () => {
            // 次の設問 又は 次の教室へ
            if(context.root.$store.state.next_field_type == NextFieldTypeEnum.Room){
              if(state.next_room_sheet_field != null && state.next_room_sheet_id != context.root.$store.state.start_sheet_id){
                toNextSheet();
              }else{
                const msg = context.root.$store.getters.isEntranceOrPractice ? "最後の教室を採点しました。試験一覧へ移動します。よろしいですか？" : "最後の教室を採点しました。一覧へ移動します。よろしいですか？";
                if(await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage(msg))){
                  sendSaitenData(context.root.$store.state.start_sheet_id, null, context.root.$store.getters.isEntranceOrPractice);
                }
              }
            }else{
              if(state.next_sheet_field != null){
                toNextField();
              }else if(await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("最後の設問を採点しました。一覧へ移動します。よろしいですか？"))){
                sendSaitenData(state.currentSheet.id, null, false);
              }
            }
          }, 100);
        }
      }else{
        state.selectedIdx++;
        scrollTableArea();
      }
    }

    /************************************************************
     * 表示対象の切り出し画像切り替え
     ************************************************************/

    const changeSelectedIdx = async (idx: number) => {
      if(selectedFieldActivity.value){
        selectedFieldActivity.value.scoreStamps.forEach(x => x.isActive = false);
      }
      state.selectedIdx = idx;
      changeSelectedTensakuText(null);
    }

    /************************************************************
     * 次の生徒へ表示対象の切り出し画像切り替え
     ************************************************************/

    const selectedIdxUp = () => {
      if(state.selectedIdx + 1 < state.fieldActivities.length){
        state.selectedIdx++;
        scrollTableArea();
        changeSelectedTensakuText(null);
      }
    }

    /************************************************************
     * 前の生徒へ表示対象の切り出し画像切り替え
     ************************************************************/

    const selectedIdxDown = () => {
      if(state.selectedIdx - 1 >= 0){
        state.selectedIdx--;
        scrollTableArea();
        changeSelectedTensakuText(null);
      }
    }

    /************************************************************
     * コンテキストメニュー表示
     ************************************************************/

    const showContextMenu = (pagePos: Common.Point, stampPos: Common.Point) => {
      state.pagePos = pagePos;
      state.stampPos = stampPos;
      state.isShowContextMenu = true;
      changeSelectedTensakuText(null);
    }

    /************************************************************
     * コンテキストメニュー非表示切り替え
     ************************************************************/

    const hideContextMenu = () => {
      state.isShowContextMenu = false;
    }

    const contextMenuMouseDown = (e: MouseEvent) => {
      e.stopImmediatePropagation();
      e.stopPropagation();
    }

    /************************************************************
     * キー押下
     ************************************************************/

    const keyUp = (e:KeyboardEvent) => {
      state.keyCode = "";

      if(e.key == "e" || e.key == "d"){
        // 現在描画中のcanvasを保持
        saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
          if(x.idx == state.selectedIdx){
            x.resetDrawingByKeyUp();
          }
        });
      }
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

    const keyDown = async (e: KeyboardEvent) => {

      state.keyCode = "";
      
      // API通信中は処理しない
      if(!isShortcutEditable.value){
        return;
      }

      // input type="text" or textareaがフォーカスされている場合は処理しない
      if (document.activeElement instanceof HTMLTextAreaElement ||
        (document.activeElement instanceof HTMLInputElement && document.activeElement.type === "text")) {
        return;
      }

      if((state.isSaitenEnable && e.key == "s") || (state.isTensakuEnable && ["e", "d", "t"].includes(e.key))){
        state.keyCode = e.key;
      }

      e.preventDefault();
      if(["1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(e.key)){
        // 部分点プルダウン切り替え
        let score = state.selectedScore < 0 ? -(Number(e.key)) : Number(e.key);
        if(state.scoreOptions.map((x: any) => x.value).includes(score)){
          state.selectedScore = score;
        }
      }else if(e.key == ";" || e.key == "+"){
        // 部分点プラス
        if(state.selectedScore < state.currentSheetField.allot){
          state.selectedScore = state.selectedScore == -1 ? 1 : state.selectedScore + 1;
        }
      }else if(e.key == "-"){
        // 部分点マイナス
        if(state.selectedScore > -state.currentSheetField.allot){
          state.selectedScore = state.selectedScore == 1 ? -1 : state.selectedScore - 1;
        }
      }else if(["x", "f"].includes(e.key) && state.isSaitenEnable){
        // 誤答採点
        await updateCorrectState(CorrectStateEnum.Gotou, 0);
      }else if(["o", "a"].includes(e.key) && state.isSaitenEnable){
        // 誤答採点
        await updateCorrectState(CorrectStateEnum.Seitou, state.currentSheetField.allot);
      }else if(["Enter", "ArrowLeft", "ArrowRight"].includes(e.key)){
        
        let nextIdx = state.selectedIdx;

        if(e.key == "ArrowLeft"){
          // 左矢印 前の切り出しへ
          nextIdx = state.selectedIdx - 1;
          if(nextIdx < 0){
            return;
          }
        }else if(e.key == "ArrowRight" || e.key == "Enter"){
          
          // 最終切り出しでエンターor右矢印キーの場合、次の設問へ移動
          // エンターキー モーダル用時中の場合はモーダルを閉じる それ以外は後続処理で次の設問へ画面遷移
          if(e.key == "Enter" && modalCorrectImageRef.value.$data.isShow){
            modalCorrectImageRef.value.hide();
          }else if(e.key == "Enter" && modalAddtionRef.value.$data.isShow){
            modalAddtionRef.value.hide();
          }else if(state.selectedIdx + 1 == state.fieldActivities.length){
            
            // 最終切り出しでEnter or 右矢印は次の設問 又は 次の教室へ
            if(context.root.$store.state.next_field_type == NextFieldTypeEnum.Room){
              if(state.next_room_sheet_field != null && state.next_room_sheet_id != context.root.$store.state.start_sheet_id){
                toNextSheet();
              }else{
                if(!state.isSaitenEnable && !state.isTensakuEnable){
                  if(context.root.$store.getters.isEntranceOrPractice){
                    await toSheetList(true);
                  }else{
                    await toSaitenList(true);
                  }
                }else{
                  const msg = context.root.$store.getters.isEntranceOrPractice ? "最後の教室を採点しました。試験一覧へ移動します。よろしいですか？" : "最後の教室を採点しました。一覧へ移動します。よろしいですか？";
                  if(await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage(msg))){
                    await sendSaitenData(context.root.$store.state.start_sheet_id, null, context.root.$store.getters.isEntranceOrPractice);
                  }
                }
              }
            }else{
              if(state.next_sheet_field != null){          
                toNextField();
              }else{
                if(!state.isSaitenEnable && !state.isTensakuEnable){
                  await toSaitenList(true);
                }else{
                  const msg = state.isSaitenEnable ? "最後の設問を採点しました。一覧へ移動します。よろしいですか？" : "一覧に移動します。よろしいですか？";
                  if(await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage(msg))){
                    await sendSaitenData(state.currentSheet.id, null, false);
                  }
                }
              }
            }
          }else{
            // 右矢印 次の切り出しへ
            nextIdx =  state.selectedIdx + 1;
          }
        }
        changeSelectedIdx(nextIdx);
        scrollTableArea();

      }else if(e.key == "w"){
        // Wキー 模範解答モーダル表示
        state.isDispCorrectImage = !state.isDispCorrectImage;
        context.root.$nextTick(() => {
          fitToImageArea();
        });

        // modalCorrectImageRef.value.show();
      }else if(e.key == "Backspace"){
        if(selectedFieldActivity.value){
          const activeScoreStamps = selectedFieldActivity.value.scoreStamps.filter(x => x.isActive);
          if(state.isSaitenEnable && activeScoreStamps.length > 0){
            // 得点スタンプ削除
            activeScoreStamps.forEach(x => {
              const idx = selectedFieldActivity.value.scoreStamps.indexOf(x);
              deleteScoreStamp(state.selectedIdx, idx);
            }); 
          }else if(state.isTensakuEnable && state.selectedTensakuText){
            const idx = selectedFieldActivity.value.tensakuTexts.indexOf(state.selectedTensakuText);
            deleteTensakuText(state.selectedIdx, idx);
            selectedFieldActivity.value.isTextEdited = true;
          }else if(state.selectedSaitenStickyNote && (state.isSaitenEnable || state.isTensakuEnable)){
            deleteSaitenStickyNote();
          }else if(state.isSaitenEnable){
            if(context.root.$store.getters.isEntranceOrPractice && state.currentSheet.approval_flg){
              await Common.customAlert(context.root.$bvModal, context.root.$store, `承認済みの試験のため、採点内容の変更はできません。`);
              return;
            }else if(context.root.$store.getters.isCompare){
              await Common.customAlert(context.root.$bvModal, context.root.$store, `コンペア採点は採点内容をクリアできません。変更のみ可能です。`);
              return;
            }
            // 採点内容クリア
            selectedFieldActivity.value.correct_state = null;
            selectedFieldActivity.value.score = null;
            selectedFieldActivity.value.scoreStamps = [];
            // 選択中の切り出しのcanvasをクリア
            saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
              if(x.idx == state.selectedIdx){
                x.clearCanvas();
              }
            });
          }
        }else if(state.selectedSaitenStickyNote && (state.isSaitenEnable || state.isTensakuEnable)){
          deleteSaitenStickyNote();
        }
      }else if(e.key == "n"){
        if(state.next_room_sheet_field != null){          
          toNextSheet();
        }
      }else if(e.key == "m"){
        if(state.next_sheet_field != null){          
          toNextField();
        }
      }else if(e.key == "q"){
        // Qキー 縮小
        state.inputScale -= 10;
      }else if(e.key == "g"){
        // Gキー 拡大
        state.inputScale += 10;
      }else if(e.key == "h"){
        // Hキー 保存して戻る
        if(state.isSaitenEnable || state.isTensakuEnable){
          toSaitenListWithSendSaitenData();
        }else{
          toSaitenList(true);
        }
      }else if(e.key == "c" && e.ctrlKey){
        const activeScoreStamps = selectedFieldActivity.value ? selectedFieldActivity.value.scoreStamps.filter(x => x.isActive) : [];
        if(state.isSaitenEnable && activeScoreStamps.length > 0){
          // 得点スタンプコピー
          const copiedStamp = new ScoreStamp();
          copiedStamp.score = activeScoreStamps[0].score;
          copiedStamp.x = activeScoreStamps[0].x;
          copiedStamp.y = activeScoreStamps[0].y;
          copiedStamp.width = activeScoreStamps[0].width;
          copiedStamp.height = activeScoreStamps[0].height;
          copiedStamp.color = activeScoreStamps[0].color;
          state.copiedStamp = copiedStamp;
          Common.showToast(context.root.$bvToast, "得点スタンプをコピーしました。");
        }else if(state.isTensakuEnable && state.selectedTensakuText){
          // テキストスタンプコピー
          const copiedStamp = new TensakuText();
          copiedStamp.text = state.selectedTensakuText.text;
          copiedStamp.font_size = state.selectedTensakuText.font_size;
          copiedStamp.line_height = state.selectedTensakuText.line_height;
          copiedStamp.color = state.selectedTensakuText.color;
          copiedStamp.x = state.selectedTensakuText.x;
          copiedStamp.y = state.selectedTensakuText.y;
          copiedStamp.width = state.selectedTensakuText.width;
          copiedStamp.height = state.selectedTensakuText.height;
          copiedStamp.direction = state.selectedTensakuText.direction;
          copiedStamp.base64_text = state.selectedTensakuText.base64_text;
          state.copiedStamp = copiedStamp;
          Common.showToast(context.root.$bvToast, "添削テキストをコピーしました。");
        }else if((state.isSaitenEnable || state.isTensakuEnable) && state.selectedSaitenStickyNote){
          const copiedStamp = new SaitenStickyNote();
          copiedStamp.comment = state.selectedSaitenStickyNote.comment;
          copiedStamp.color = state.selectedSaitenStickyNote.color;
          copiedStamp.x = state.selectedSaitenStickyNote.x;
          copiedStamp.y = state.selectedSaitenStickyNote.y;
          copiedStamp.width = state.selectedSaitenStickyNote.width;
          copiedStamp.height = state.selectedSaitenStickyNote.height;
          state.copiedStamp = copiedStamp;
          Common.showToast(context.root.$bvToast, "付箋をコピーしました。");
        }
      }else if(e.key == "v" && e.ctrlKey && state.copiedStamp != null){
        if(!selectedFieldActivity.value){
          return;
        }
        state.selectedTensakuText = null;
        selectedFieldActivity.value.scoreStamps.forEach(x => x.isActive = false);
        if(state.isSaitenEnable && state.copiedStamp instanceof ScoreStamp){
          // 得点スタンプペースト(参照を切るために一旦json化して別インスタンスとしてペースト)
          const pasteStamp = JSON.parse(JSON.stringify(state.copiedStamp)) as ScoreStamp;

          // 同じ座標・サイズ・点数の得点スタンプが出力済みの場合、確認メッセージを表示
          // 出力しても見た目上、完全に重なってしまい誤ったペーストの場合気づかない可能性があるため
          // 例> 1点スタンプ出力⇒コピー⇒同じ切出しにペースト⇒完全に重なった状態でペーストされて見た目変わらずなのに得点だけ変わるのでバグと勘違いされる
          if(selectedFieldActivity.value.scoreStamps.filter(x => x.x == pasteStamp.x && x.y == pasteStamp.y && x.score == pasteStamp.score).length > 0){
            if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "同じ位置・サイズ・点数の得点スタンプが既に出力されています。得点スタンプをペーストしますか？")){
              return;
            }
          }

          pasteStamp.idx = selectedFieldActivity.value.scoreStampIdx++;
          pasteStamp.field_activity_id = selectedFieldActivity.value.id;
          pasteStamp.isActive = true;
          selectedFieldActivity.value.scoreStamps.push(pasteStamp);
          calcScoreByScoreStamp(state.selectedIdx);
          Common.showToast(context.root.$bvToast, "得点スタンプをペーストしました。");
        }else if(state.isTensakuEnable && state.copiedStamp instanceof TensakuText){
          // テキストスタンプペースト(参照を切るために一旦json化して別インスタンスとしてペースト)
          const pasteStamp = JSON.parse(JSON.stringify(state.copiedStamp)) as TensakuText;
          pasteStamp.field_activity_id = selectedFieldActivity.value.id;
          pasteStamp.idx = selectedFieldActivity.value.tensakuTextIdx++;
          selectedFieldActivity.value.tensakuTexts.push(pasteStamp);
          state.selectedTensakuText = pasteStamp;
          selectedFieldActivity.value.isTextEdited = true;
          Common.showToast(context.root.$bvToast, "添削テキストをペーストしました。");
        }else if((state.isSaitenEnable || state.isTensakuEnable) && state.copiedStamp instanceof SaitenStickyNote){
          const pasteStickyNote = JSON.parse(JSON.stringify(state.copiedStamp)) as SaitenStickyNote;
          pasteStickyNote.field_activity_id = selectedFieldActivity.value.id;
          pasteStickyNote.idx = selectedFieldActivity.value.saitenStickyNoteIdx++;
          pasteStickyNote.id = null;
          pasteStickyNote.is_show_popover = false;
          selectedFieldActivity.value.saitenStickyNotes.push(pasteStickyNote);
          selectedFieldActivity.value.isStickyNoteEdited = true;
          state.selectedSaitenStickyNote = pasteStickyNote;
          Common.showToast(context.root.$bvToast, "付箋をペーストしました。");
        }
      }else if(e.key == "b" && (state.isSaitenEnable || state.isTensakuEnable)){
        // 付箋追加
        addSaitenStickyNote();
      }
    };

    /****************************************
     * 一覧スクロール
     ****************************************/

    const scrollTableArea = () => {
      if(state.selectedIdx == null){
        return;
      }
      const scrollArea = document.getElementById("table-area");
      const trArea = document.getElementById(`tr-${state.selectedIdx}`);
      const labelScoringtype = document.getElementById("label-scoring-type");

      const scrollAreaHeight = scrollArea.offsetHeight - labelScoringtype.offsetHeight * 2;
      const scrollAreaTop = scrollArea.scrollTop - labelScoringtype.offsetHeight * 2;
      const scrollAreaBottom = scrollAreaTop + scrollAreaHeight;
      const trTop = trArea.offsetTop;
      const trBottom = trArea.offsetTop + trArea.offsetHeight;
      
      if(state.selectedIdx == 0){
        scrollArea.scrollTop = 0;
      }else if(scrollAreaTop > trTop){
        scrollArea.scrollTop -= trArea.offsetHeight;
      }else if(scrollAreaBottom < trBottom){
        scrollArea.scrollTop += trArea.offsetHeight;
      }
    }

    /************************************************************
     * 採点内容変更フラグ更新
     * 入試・模試で2次採点以降に採点内容を変更した場合にフラグを立てる
     ************************************************************/

    const setCorrect = (fieldActivity: FieldActivity, correct_state: number, score: number) => {

      fieldActivity.correct_state = correct_state;
      fieldActivity.score = score;

      if(fieldActivity.correct_state_cache != null){
        const isCorrectChanged = fieldActivity.correct_state != fieldActivity.correct_state_cache || fieldActivity.score != fieldActivity.score_cache || isStampChanged(fieldActivity) ? true : fieldActivity.is_correct_changed_cache;
        fieldActivity.is_correct_changed = isCorrectChanged;
      }
    }

    /************************************************************
     * 得点スタンプ編集有無判定
     ************************************************************/

    const isStampChanged = (fieldActivity: FieldActivity) => {
      return JSON.stringify(fieldActivity.scoreStamps) != JSON.stringify(fieldActivity.scoreStampCaches);
    }

    /************************************************************
     * CLEARボタン押下
     ************************************************************/

    const clearCorrect = async () => {
      blur();

      if(context.root.$store.getters.isEntranceOrPractice && state.currentSheet.approval_flg){
        await Common.customAlert(context.root.$bvModal, context.root.$store, `承認済みの試験のため、採点内容の変更はできません。`);
        return;
      }

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "画面に表示されている採点内容のデータを削除します。よろしいですか？")){
        return;
      }

      // パラメータ用FieldActivities
      const paramFieldActivities = new Array<ParamFieldActivity>();
      state.fieldActivities.forEach(x => {
        paramFieldActivities.push(new ParamFieldActivity(x));
      });

      context.root.$store.dispatch("showOverlay");

      await http.post(`/api/teacher/saiten_input_score_stamp/clear_correct/${state.sheet_field_id}`, {field_activities: JSON.stringify(paramFieldActivities)}).then(async response => {
        await Common.customAlert(context.root.$bvModal, context.root.$store, `採点内容のクリアに成功しました。`);
        window.location.reload();
      })
      .catch(async error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 採点一覧へ遷移
     ************************************************************/

    const toSaitenList = async (isDispSaveConfirm: boolean = false) => {
      const msg = !state.isSaitenEnable && !state.isTensakuEnable ? "一覧に戻ります。よろしいですか？" : "採点結果は保存されません。よろしいですか？";
      if(isDispSaveConfirm && !await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage(msg))){
        return;
      }
      context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(() => {});
    };

    /************************************************************
     * 保存せず試験一覧へ遷移
     ************************************************************/

     const toSheetList = async (isDispSaveConfirm: boolean = false) => {
      const msg = !state.isSaitenEnable && !state.isTensakuEnable ? "試験一覧に戻ります。よろしいですか？" : "採点結果は保存されません。よろしいですか？";
      if(isDispSaveConfirm && !await Common.customConfirm(context.root.$bvModal, context.root.$store, msg)){
        return;
      }
      context.root.$store.dispatch("goSheetList");
    };

    /************************************************************
     * 保存して採点一覧へ遷移
     ************************************************************/

    const toSaitenListWithSendSaitenData = async () => {
      blur();

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("採点内容を保存して採点一覧に戻ります。よろしいですか？"))){
        return;
      }

      sendSaitenData(state.currentSheet.id, null, false);
    };

    /************************************************************
     * 前の設問へ遷移
     ************************************************************/

    const toPrevField = async () => {
      blur();
      if(state.isSaitenEnable || state.isTensakuEnable){
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("前の設問へ移動します。よろしいですか？"))){
          return;
        }
        sendSaitenData(state.currentSheet.id, state.prev_sheet_field, false);
      }else{
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "前の設問へ移動します。よろしいですか？")){
          return;
        }
        changeFieldWithResetLastScored(Number(state.sheet_id), state.prev_sheet_field);
      }
    };

    /************************************************************
     * 次の設問へ遷移
     ************************************************************/

    const toNextField = async () => {
      blur();

      if(state.isSaitenEnable || state.isTensakuEnable){
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("次の設問へ移動します。よろしいですか？"))){
          return;
        }
        sendSaitenData(state.currentSheet.id, state.next_sheet_field, false);
      }else{
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "次の設問へ移動します。よろしいですか？")){
          return;
        }
        changeFieldWithResetLastScored(Number(state.sheet_id), state.next_sheet_field);
      }
      
    };

    /************************************************************
     * 次の教室へ遷移
     ************************************************************/

    const toNextSheet = async () => {
      blur();

      if(state.isSaitenEnable || state.isTensakuEnable){
        const msg = state.is_last_room ? "先頭の教室に戻ります。よろしいですか？" : "次の教室へ移動します。よろしいですか？";
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage(msg))){
          return;
        }
        sendSaitenData(state.next_room_sheet_id, state.next_room_sheet_field, false);
      }else{
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "次の教室へ移動します。よろしいですか？")){
          return;
        }
        changeFieldWithResetLastScored(state.next_room_sheet_id, state.next_room_sheet_field);
      }
    };

    /************************************************************
     * 前の教室へ遷移
     ************************************************************/

    const toPrevSheet = async () => {
      blur();

      if(state.isSaitenEnable || state.isTensakuEnable){
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("前の教室へ移動します。よろしいですか？"))){
          return;
        }
        sendSaitenData(state.prev_room_sheet_id, state.prev_room_sheet_field, false);
      }else{
        if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "保存せず前の教室へ移動します。よろしいですか？")){
          return;
        }
        changeFieldWithResetLastScored(state.prev_room_sheet_id, state.prev_room_sheet_field);
      }
    };

    /************************************************************
     * メモ更新API
     ************************************************************/

    const updateAddition = async () => {
      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, "メモを更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/saiten_input_score_stamp/update_addition/${state.sheet_field_id}`, {addition: state.currentSheetField.addition}).then(async response => {
        modalAddtionRef.value.hide();
      })
      .catch(async error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /************************************************************
     * 2次採点以降の採点内容変更判定
     * 入試・模試の2次採点以降で採点内容変更の場合true, それ以外はfalse
     ************************************************************/

    const isExistsCorrectChangedField = () => {
      const correctUpdatedIds = state.fieldActivities.filter(x => x.correct_state != x.correct_state_cache || x.score != x.score_cache || isStampChanged(x)).map(x => x.id);
      const canvasUpdatedIds = state.fieldActivities.filter(x => x.isCanvasEdited).map(x => x.id);
      return context.root.$store.getters.isEntranceOrPractice && !isFirstScoring() && (correctUpdatedIds.length > 0 || canvasUpdatedIds.length > 0);
    }

    /************************************************************
     * 登録前の確認メッセージ取得
     * 入試・模試で2次採点以降の採点内容変更の場合は固定の文言、それ以外は各操作のデフォルト文言
     ************************************************************/

    const getConfirmMessage = (defaultMessage: string) => {
      if(context.root.$store.getters.isEntranceOrPractice && isExistsCorrectChangedField()){
        return "採点内容を変更しました。よろしいですか？";
      }else{
        return defaultMessage;
      }
    }

    /************************************************************
     * 1次採点か判定
     ************************************************************/
    const isFirstScoring = () => {
      
      if(state.currentSheet.verify_count == 2){
        if(state.currentSheetField.first_scorers_id && state.currentSheetField.second_scorers_id){
          // 2次採点まで完了している
          return false
        }else if(state.currentSheetField.first_scorers_id && !state.currentSheetField.second_scorers_id
          && state.currentSheetField.first_scorers_id != context.root.$store.state.currentUser.id){
          // 1次採点完了、2次採点中
          return false;
        }else{
          return true;
        }
      }else if(state.currentSheet.verify_count == 3){
        if(state.currentSheetField.first_scorers_id && state.currentSheetField.second_scorers_id && state.currentSheetField.third_scorers_id){
          // 3次採点まで完了している
          return false;
        }else if(!state.currentSheetField.third_scorers_id && state.currentSheetField.second_scorers_id && state.currentSheetField.first_scorers_id){
          // 2次採点まで完了している
          return false;
        }else if(!state.currentSheetField.second_scorers_id && state.currentSheetField.first_scorers_id && state.currentSheetField.first_scorers_id != context.root.$store.state.currentUser.id){
          // 1次採点完了、2次採点中
          return false;
        }else{
          return true;
        }
      }
    }

    /************************************************************
     * 採点データ保存API
     ************************************************************/

    const sendSaitenData = async (sheet_id: number, next_sheet_field: SheetField, isGoSheetList: boolean = false) => {

      // コンペアは未採点状態で保存不可
      // 採点済み⇒未採点に変更された場合、AB最終全て同期で未採点に戻ってしまうため
      if(context.root.$store.getters.isCompare && state.fieldActivities.filter(x => x.correct_state == null).length > 0){
        alert("コンペア採点は未採点が存在する状態で保存できません。全て採点してください。");
        return;
      }

      // 採点内容 or Canvasに変更が生じたsheet_acrivity_id
      const correctUpdatedIds = state.fieldActivities.filter(x => x.correct_state != x.correct_state_cache || x.score != x.score_cache || isStampChanged(x)).map(x => x.id);
      const canvasUpdatedIds = state.fieldActivities.filter(x => x.isCanvasEdited).map(x => x.id);
      const tensakuUpdatedIds = state.fieldActivities.filter(x => x.isTextEdited).map(x => x.id);
      const stickyNoteUpdateIds = state.fieldActivities.filter(x => x.isStickyNoteEdited).map(x => x.id);

      context.root.$store.dispatch("showOverlay");
      state.isProcessingApi = true;

      // 現在描画中のcanvasを保持
      saitenBoxRef.value.forEach((x: InstanceType<typeof SaitenBox>) => {
        x.setBase64Canvas();
      });
      
      // 添削画像をZip化
      let zip = new jsZip();
      state.fieldActivities.forEach(x => {
        if(x.isCanvasEdited){
          zip.file(`${x.id}.png`, x.base64Canvas, {base64: true});
        }

        if(x.isTextEdited){
          x.tensakuTexts.filter(x => x.text != null && x.text.replace(/\r?\n/g, '').trim() != "" && x.width > 0 &&  x.height > 0).forEach(y => {
            zip.file(`tensaku_text_${y.field_activity_id}_${y.idx}.png`, y.base64_text, {base64: true});
          });
        }
      });

      await zip.generateAsync({type: "blob"}).then(async (blob) => {
        if(!blob){
          return;
        }

        // パラメータ用FieldActivities
        const paramFieldActivities = new Array<ParamFieldActivity>();
        state.fieldActivities.forEach(x => {
          paramFieldActivities.push(new ParamFieldActivity(x));
        });

        const fd = new FormData();
        fd.append("file", blob);
        fd.append("field_activities", JSON.stringify(paramFieldActivities));
        fd.append("processing_time", `${state.processingTime}`);
        fd.append("sheet_field_id", state.sheet_field_id);
        fd.append("scoring_type", `${state.currentSheetField.scoring_type}`);
        fd.append("correct_updated_ids", JSON.stringify(correctUpdatedIds));
        fd.append("canvas_updated_ids", JSON.stringify(canvasUpdatedIds));
        fd.append("tensaku_updated_ids", JSON.stringify(tensakuUpdatedIds));
        fd.append("sticky_note_updated_ids", JSON.stringify(stickyNoteUpdateIds));
        if(context.root.$store.getters.isCompareFirstOrSecond){
          fd.append("compare_no", context.root.$store.state.compare_no);
        }

        await http.post(`/api/teacher/saiten_input_score_stamp/update/${state.sheet_id}`, fd).then(async response => {
          
          if(next_sheet_field != null){
            if(next_sheet_field.scoring_type == Common.ScoringTypeEnum.Seigo){
              // 正誤採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input/${sheet_id}/${next_sheet_field.id}`
              context.root.$router.push(toUrl).catch(() => {});
            }else{
              // 得点スタンプ採点画面へ遷移
              const toUrl = `/teacher_site/saiten_input_score_stamp/${sheet_id}/${next_sheet_field.id}`
              state.selectedIdx = -1;
              context.root.$router.push(toUrl).catch(() => {});
              context.root.$nextTick(() => {
                window.location.reload();
              });
            }
          }else{
            // 採点一覧 or 試験一覧へ戻る
            if(isGoSheetList){
              context.root.$store.dispatch('goSheetList');
            }else{
              context.root.$router.push(`/teacher_site/saiten_list/${sheet_id}`).catch(() => {});
            }
          }
        })
        .catch(async error=>{
          context.root.$store.dispatch("hideOverlay");
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      });
    };

    /************************************************************
     * 排他制御解除して別設問へ移動するAPI
     ************************************************************/
    const changeFieldWithResetLastScored = async (next_sheet_id: number, next_sheet_field: SheetField) => {

      context.root.$store.dispatch("showOverlay");
      state.isProcessingApi = true;

      await http.post(`/api/teacher/saiten_input_score_stamp/reset_last_scored/${state.sheet_field_id}`).then(async response => {
        if(next_sheet_id != null){
          if(next_sheet_field.scoring_type == Common.ScoringTypeEnum.Seigo){
            // 正誤採点画面へ遷移
            const toUrl = `/teacher_site/saiten_input/${next_sheet_id}/${next_sheet_field.id}`
            context.root.$router.push(toUrl).catch(() => {});
          }else{
            // 得点スタンプ採点画面へ遷移
            const toUrl = `/teacher_site/saiten_input_score_stamp/${next_sheet_id}/${next_sheet_field.id}`
            context.root.$router.push(toUrl).catch(() => {});
            context.root.$nextTick(() => {
              window.location.reload();
            });
          }
        }else{
          // 採点一覧へ戻る
          context.root.$router.push(`/teacher_site/saiten_list/${state.sheet_id}`).catch(() => {});
        }
      })
      .catch(async error=>{
        context.root.$store.dispatch("hideOverlay");
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 初期表示データ取得API
     ************************************************************/

    const initialize = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      state.sheet_field_id = context.root.$route.params.sheet_field_id;

      if(state.timer != null){
        clearInterval(state.timer);
      }

      let confirmMessage = null;
      let browsableSheetErrMessage = null;
      let url = `/api/teacher/saiten_input_score_stamp/check_saiten_lock/${state.sheet_field_id}`;
      if(context.root.$store.getters.isCompareFirstOrSecond){
        url += `?compare_no=${context.root.$store.state.compare_no}`;
      }
      await http.get(url).then(async response => {
        confirmMessage = response.data.confirm_message;
        browsableSheetErrMessage = response.data.browse_lock_err_message;
      })
      .catch(async error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if (browsableSheetErrMessage != null) {
        await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${browsableSheetErrMessage}`);
        context.root.$router.push(`/teacher_site/sheet_list/`).catch(() => {});
        return;
      }

      // 他者排他制御中の場合は確認メッセージ
      if(confirmMessage != null){
        if(!window.confirm(confirmMessage)){
          state.allowResetSaitenLock = false;
          toSaitenList();
          return;
        }
      }

      url = `/api/teacher/saiten_input_score_stamp?sheet_id=${state.sheet_id}&sheet_field_id=${state.sheet_field_id}&version=20260224`;
      if(context.root.$store.getters.isCompareFirstOrSecond){
        url += `&compare_no=${context.root.$store.state.compare_no}`;
      }
      await http.get(url).then(async response => {

        browsableSheetErrMessage = response.data.browse_lock_err_message;
        if (browsableSheetErrMessage != null) {
          return;
        }

        state.currentSheet = new Sheet(response.data.current_sheet);
        state.currentSheetField = new SheetField(response.data.current_sheet_field, response.data.buff_size);        
        state.fieldActivities = response.data.field_activities.map((x: any) => new FieldActivity(x, response.data.sheet_activities, response.data.examinees, response.data.cut_image_url_hash_array, response.data.base64_canvas_hash_array, state.currentSheet.page_count, response.data.score_stamps, response.data.tensaku_texts, response.data.saiten_sticky_notes));
        state.correctImageUrl = response.data.correct_image_url;
        state.next_room_sheet_id = response.data.next_room_sheet_id;
        state.next_room_sheet_field =  response.data.next_room_sheet_field ? new SheetField(response.data.next_room_sheet_field, response.data.buff_size) : null;
        state.prev_room_sheet_id = response.data.prev_room_sheet_id;
        state.prev_room_sheet_field = response.data.prev_room_sheet_field ? new SheetField(response.data.prev_room_sheet_field, response.data.buff_size) : null;
        state.prev_sheet_field = response.data.prev_sheet_field ? new SheetField(response.data.prev_sheet_field, response.data.buff_size) : null;
        state.next_sheet_field = response.data.next_sheet_field ? new SheetField(response.data.next_sheet_field, response.data.buff_size) : null;
        state.is_first_room = response.data.is_first_room;
        state.is_last_room = response.data.is_last_room;
        state.warningDispTime = Date.now() + response.data.warning_disp_time;
        state.selectedIdx = 0;
        state.processingTime = 0;
        state.carouselPageIdx = state.currentSheetField.page -1;
        state.scoring_type_name = Common.GetScoringTypeNameByCode(state.currentSheetField.scoring_type);

        state.isDispStudentInfo = !state.currentSheet.is_mask_student_info || context.root.$store.getters.isAdminOrTeacher1 || !context.root.$store.getters.isEntranceOrPractice;
        state.isExistsStudentNoCharacter = state.fieldActivities.filter(x => x.examinee.student_no_character != null && x.examinee.student_no_character != "").length > 0;
        state.isExistsStudentName = state.fieldActivities.filter(x => x.examinee.student_name != null && x.examinee.student_name != "").length > 0;

        // 部分点プルダウン生成
        state.scoreOptions = new Array<any>();
        for(let i = -state.currentSheetField.allot; i <= state.currentSheetField.allot; i++){
          if(i != 0){
            state.scoreOptions.push({value: i, text: `${i}点`});
          }
        }

        // 部分点プルダウン初期選択値設定
        state.selectedScore = state.currentSheetField.scoring_type == Common.ScoringTypeEnum.ScoreStampPlus ? 1 : -1;

        // コンテキストメニューの部分点ボタンバインド用配列生成
        const contextScoreRows = [];
        let contextScoreCols = [];
        for(let i = 1; i <= state.currentSheetField.allot; i++){
          contextScoreCols.push(i);
          if(i % 10 == 0 || i == state.currentSheetField.allot){
            contextScoreRows.push(contextScoreCols);
            contextScoreCols = [];
          }
        }
        for(let i = 1; i <= state.currentSheetField.allot; i++){
          contextScoreCols.push(-i);
          if(i % 10 == 0 || i == state.currentSheetField.allot){
            contextScoreRows.push(contextScoreCols);
            contextScoreCols = [];
          }
        }
        state.contextScoreRows = contextScoreRows;

        // 数字入力プルダウン生成
        state.tensakuNumberOptions = new Array<any>();
        for(let i = -100; i < 101; i++){
          state.tensakuNumberOptions.push({value: i, text: `${i}`});
        }

        // フォントサイズプルダウン生成
        state.fontSizeOptions = new Array<any>();
        for(let i = 5; i < 101; i++){
          state.fontSizeOptions.push({value: i, text: i});
        }
        
        if(context.root.$store.getters.isEntranceOrPractice){
          if(state.currentSheet.verify_count == 2){
            if(state.currentSheetField.first_scorers_id){
              state.verifyNo = 2;
            }else{
              state.verifyNo = 1;
            }
          }else if(state.currentSheet.verify_count == 3){
            if(state.currentSheetField.second_scorers_id){
              state.verifyNo = 3;
            }else if(state.currentSheetField.first_scorers_id){
              state.verifyNo = 2;
            }else{
              state.verifyNo = 1;
            }
          }
        }

        // 採点操作の可否判定
        state.isSaitenEnable = response.data.is_saiten_enable;
        state.isTensakuEnable = response.data.is_tensaku_enable;
        state.saitenDisableReason = response.data.saiten_disable_reason;

        context.root.$store.commit("setSheetFieldIdx", response.data.sheet_field_idx);
      })
      .catch(async error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。設問一覧に戻ります。`);
        }
        toSaitenList();
      });

      if (browsableSheetErrMessage != null) {
        await Common.customAlert(context.root.$bvModal, context.root.$store, `試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${browsableSheetErrMessage}`);
        context.root.$router.push(`/teacher_site/sheet_list/`).catch(() => {});
        return;
      }

      if(!state.isWindowEventAdded){
        window.addEventListener("keyup", keyUp);
        window.addEventListener("keydown", keyDown);
        window.addEventListener("resize", adjustLayout);
      }

      state.direction = state.currentSheetField.baseWidth > state.currentSheetField.baseHeight ? DirectionEnum.Horizon : DirectionEnum.Vertical;
      
      if(state.fieldActivities.filter(x => x.correct_state != null).length > 0){
        // 採点済みデータありの場合は○×順表示で表示
        changeSortKind(SortKindEnum.CorrectState, true);
      }else{
        // 全件未採点の場合は番号順で表示
        changeSortKind(SortKindEnum.No, true);
      }

      state.isInitialized = true;

      adjustLayout();
      state.processingTime = 0;
      state.isShowSessionMsg = false;
      state.isWarningTimeReached = false;
      state.timer = setInterval(() => {
        state.processingTime++;
        if(!state.isWarningTimeReached && Date.now() >= state.warningDispTime){
          state.isShowSessionMsg = true;
          state.isWarningTimeReached = true;
        }
      }, 1000);

      context.root.$nextTick(() => {
        const separateWidth = (state.mainAreaWidth - state.separatorSize) / 2;
        const separateHeight = (state.mainAreaHeight - state.separatorSize) / 2;
        state.verticalLeftWidthPer = separateWidth / state.mainAreaWidth;
        state.verticalRightWidthPer = separateWidth / state.mainAreaWidth;
        state.horizonTopHeightPer = separateHeight / state.mainAreaHeight;
        state.horizonBottomHeightPer = separateHeight / state.mainAreaHeight;

        const saitenBoxArea = document.getElementById("saiten-box-area");
        state.scrollBarSize = saitenBoxArea.offsetWidth - saitenBoxArea.clientWidth;
        fitToImageArea();
      });

      const imageArea: HTMLElement = document.getElementById("image-area");
      imageArea.scrollTop = 0;

      state.isProcessingApi = false;
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削画像Base64文字列をセット
     ************************************************************/

    const setBase64Canvas = (idx: number, base64Canvas: string) => {
      state.fieldActivities[idx].base64Canvas = base64Canvas;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * canvas編集フラグをセット
     ************************************************************/

    const setCanvasEdited = (idx: number) => {
      state.fieldActivities[idx].isCanvasEdited = true;
    };

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 添削テキストスタンプ追加
     ************************************************************/

    const addTensakuText = (point: Common.Point, pagePoint: Common.Point) => {
      const size = Common.getTextSize({fontSize: state.fontSize, lineHeight: state.lineHeight, direction: context.root.$store.state.textDirection});
      const tensakuText = new TensakuText();
      if(!selectedFieldActivity.value){
        return;
      }
      tensakuText.field_activity_id = selectedFieldActivity.value.id;
      tensakuText.idx = selectedFieldActivity.value.tensakuTextIdx++;
      tensakuText.font_size = state.fontSize;
      tensakuText.line_height = 0;
      tensakuText.color = state.textColor;
      tensakuText.x = point.x;
      tensakuText.y = point.y;
      tensakuText.width = size.width;
      tensakuText.height = size.height;
      tensakuText.direction = context.root.$store.state.textDirection;
      tensakuText.base64_text = Common.createBase64Text(tensakuText);
      selectedFieldActivity.value.tensakuTexts.push(tensakuText);
      state.selectedTensakuText = tensakuText;
      state.isShowContextMenu = false;
      selectedFieldActivity.value.isTextEdited = true;
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 得点スタンプ追加
     ************************************************************/

    const addScoreStamp = (point: Common.Point, score: number) => {

      if(!selectedFieldActivity.value){
        return;
      }
      selectedFieldActivity.value.scoreStamps.forEach(x => x.isActive = false);

      const scoreStamp = new ScoreStamp();
      scoreStamp.idx = selectedFieldActivity.value.scoreStampIdx++;
      scoreStamp.x = point.x;
      scoreStamp.y = point.y;
      scoreStamp.height = 50;
      scoreStamp.width = `${score}`.length * scoreStamp.height / 2;
      scoreStamp.score = score;
      scoreStamp.color = "red";
      selectedFieldActivity.value.scoreStamps.push(scoreStamp);

      calcScoreByScoreStamp(state.selectedIdx);

      state.isShowContextMenu = false;

      context.root.$nextTick(() => {
        scoreStamp.isActive = true;
      });
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * 得点スタンプ削除
     ************************************************************/

    const deleteScoreStamp = (fieldActivityIdx: number, scoreStampIdx: number) => {
      state.fieldActivities[fieldActivityIdx].scoreStamps.splice(scoreStampIdx, 1);
      
      calcScoreByScoreStamp(fieldActivityIdx);
    }

    /************************************************************
     * 得点スタンプから得点・採点内容設定
     ************************************************************/

    const calcScoreByScoreStamp = (fieldActivityIdx: number) => {
      if(state.fieldActivities[fieldActivityIdx].scoreStamps.length == 0){
        // 削除した結果スタンプが0件になった場合、未採点に戻る
        state.fieldActivities[fieldActivityIdx].score = null;
        state.fieldActivities[fieldActivityIdx].correct_state = null;
      }else{
        // ベースとなる点数を取得 加点方式の場合は0点スタート、減点方式の場合は配点からスタート
        const baesScore = state.currentSheetField.scoring_type == Common.ScoringTypeEnum.ScoreStampPlus ? 0 : state.currentSheetField.allot;

        let score = Common.sumArray(state.fieldActivities[fieldActivityIdx].scoreStamps.map(x => x.score)) + baesScore;
        // 0点を下限、配点を上限とする
        if(score < 0){
          score = 0;
        }else if(score > state.currentSheetField.allot){
          score = state.currentSheetField.allot;
        }

        let correct_state = null;

        if(score == state.currentSheetField.allot){
          // 配点以上の場合は正答
          correct_state = CorrectStateEnum.Seitou;
        }else if(score == 0){
          // 0点以下の場合は誤答
          correct_state = CorrectStateEnum.Gotou;
        }else{
          // 1点以上配点未満の場合は部分点(△)
          correct_state = CorrectStateEnum.Tokuten;
        }

        setCorrect(state.fieldActivities[fieldActivityIdx], correct_state, score);
      }
    }

    /************************************************************
     * SaitenBoxコンポーネントからのemit
     * テキストスタンプ削除
     ************************************************************/

    const deleteTensakuText = (fieldActivityIdx: number, tensakuTextIdx: number) => {
      state.fieldActivities[fieldActivityIdx].tensakuTexts.splice(tensakuTextIdx, 1);
      state.selectedTensakuText = null;
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      if(context.root.$store.state.isKaitouViewReloaded){
        context.root.$store.commit("setIsKaitouViewReloaded", false);
      }else{
        context.root.$store.commit("setIsKaitouViewReloaded", true);
        window.location.reload();
        return;
      }

      if(context.root.$store.state.fontSize != null){
        state.fontSize = context.root.$store.state.fontSize;
      }

      if(context.root.$store.state.lineHeight != null){
        state.lineHeight = context.root.$store.state.lineHeight;
      }

      await initialize();
      document.body.style.overflow = "hidden";
    });

    /************************************************************
     * before unmount windowイベント解除・排他制御解除
     ************************************************************/
    onBeforeUnmount(async () => {
      
      // タイマー停止
      if(state.timer != null){
        clearInterval(state.timer);
      }

      context.root.$store.commit("setIsHeaderDisp", true);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      window.removeEventListener("resize", adjustLayout);
      document.body.style.overflow = "";
      if(state.allowResetSaitenLock){
        await http.post(`/api/teacher/saiten_input_score_stamp/reset_last_scored/${state.sheet_field_id}`);
      }
    });

    const changeSelectedSaitenStickyNote = (target: SaitenStickyNote) => {
      if(!state.isSaitenEnable && !state.isTensakuEnable){
        return;
      }
      state.selectedSaitenStickyNote = target;
      state.fieldActivities.forEach(fieldActivity => {
        fieldActivity.saitenStickyNotes.forEach(saitenStickyNote => {
          saitenStickyNote.is_show_popover = saitenStickyNote == target;
        })
      });
    }

    const deleteSaitenStickyNote = async () => {

      if(!await Common.customConfirm(context.root.$bvModal, context.root.$store, getConfirmMessage("付箋を削除します。よろしいですか？"))){
        return;
      }

      const fieldActivity = state.fieldActivities.find(x => x.id == state.selectedSaitenStickyNote.field_activity_id);
      const idx = fieldActivity.saitenStickyNotes.indexOf(state.selectedSaitenStickyNote);
      fieldActivity.saitenStickyNotes.splice(idx, 1);
      state.selectedSaitenStickyNote = null;
      saitenStickyNoteEdited();
    }

    const showSaitenStickyNoteModal = () => {
      state.selectedSaitenStickyNote.is_show_popover = false;
      saitenStickyNoteModalRef.value.show();
    }

    const addSaitenStickyNote = () => {
      const saitenStickyNote = new SaitenStickyNote();
      if(!selectedFieldActivity.value){
        return;
      }
      saitenStickyNote.field_activity_id = selectedFieldActivity.value.id;
      saitenStickyNote.idx = selectedFieldActivity.value.saitenStickyNoteIdx++;
      saitenStickyNote.x = 5;
      saitenStickyNote.y = 5;
      saitenStickyNote.width = 30;
      saitenStickyNote.height = 30;
      selectedFieldActivity.value.saitenStickyNotes.push(saitenStickyNote);
      state.selectedSaitenStickyNote = saitenStickyNote;

      saitenStickyNoteEdited();
      showSaitenStickyNoteModal();
    }

    const saitenStickyNoteEdited = () => {
      const fieldActivity = state.fieldActivities.find(x => x.id == state.selectedSaitenStickyNote.field_activity_id);
      fieldActivity.isStickyNoteEdited = true;
    }

    return {
      ...toRefs(state),
      SaitenModeEnum,
      CorrectStateEnum,
      DirectionEnum,
      NextFieldTypeEnum,
      SortKindEnum,
      CompareNoEnum,
      saitenBoxRef,
      modalCorrectImageRef,
      modalAddtionRef,
      modalPcHelpRef,
      modalTabletHelpRef,
      modalPreviewImageRef,
      carouselRef,
      saitenStickyNoteModalRef,
      showPreviewImage,
      changeSaitenMode,
      changeSortKind,
      clearCorrect,
      setBase64Canvas,
      setCanvasEdited,
      focus,
      showModalCorrectImage,
      showModalPcHelp,
      showModalTabletHelp,
      showModalMemo,
      toSaitenList,
      toPrevField,
      toNextField,
      toNextSheet,
      toPrevSheet,
      toSaitenListWithSendSaitenData,
      updateAddition,
      base64PreviewImages,
      carouselPrev,
      carouselNext,
      changePrevModalExaminee,
      changeNextModalExaminee,
      changeSelectedIdx,
      scaleUp,
      scaleDown,
      fitToImageArea,
      selectedIdxUp,
      selectedIdxDown,
      updateCorrectState,
      addScoreStamp,
      deleteScoreStamp,
      showContextMenu,
      hideContextMenu,
      contextAreaStyle,
      contextButtonStyle,
      changeSaitenModeBySaitenBox,
      contextMenuMouseDown,
      scale,
      fieldImageWidth,
      fieldWrapWidth,
      fieldImageHeight,
      fieldWrapHeight,
      modeAreaHeaderPointerDown,
      modeAreaHeaderPointerMove,
      modeAreaHeaderPointerUp,
      modeAreaTouchMove,
      horizonHeightPaneResizing,
      verticalWidthPaneResizing,
      changeDirection,
      saitenBoxAreaHeight,
      saitenBoxAreaWidth,
      correctImageStyle,
      selectedTensakuTextElemId,
      addTensakuText,
      changeSelectedTensakuText,
      changeText,
      textFormatChanged,
      deleteTensakuText,
      changeNextFieldType,
      changeSelectedSaitenStickyNote,
      deleteSaitenStickyNote,
      addSaitenStickyNote,
      showSaitenStickyNoteModal,
      saitenStickyNoteEdited,
    };
  }
});
